/** @file Centre azimuth of a sector of a sector table (sector 0 wraps around 360). */
import type { SectorTable } from '@zilo/pose3d-format/types/facet';

/** Middle of sector `i` in degrees, in [0, 360). */
export function sectorCentre(table: SectorTable, i: number): number {
  const hi = table.thresholds[i] ?? 0;
  const lo = i === 0 ? (table.thresholds.at(-1) ?? 0) - 360 : (table.thresholds[i - 1] ?? 0);
  return ((((lo + hi) / 2) % 360) + 360) % 360;
}
